// extracted by mini-css-extract-plugin
module.exports = {"text_box":"style_text_box__1q1BZ","text":"style_text__HlMsQ"};